import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { GlitchText, useGlyphScramble, GlyphDisplay } from "./animations"

const MotionLink = motion(Link)

export function CTASection() {
  const { characters, display, startLoop, stopLoop } = useGlyphScramble("Get Started Free", { scrambleInterval: 28 })

  return (
    <section className="py-24 px-6" style={{ background: "var(--bg)" }}>
      <div className="mx-auto" style={{ maxWidth: "800px" }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="relative p-8 md:p-12 text-center"
          style={{
            background: "rgba(18, 18, 22, 0.8)",
            border: "2px solid rgba(255, 43, 79, 0.3)",
            boxShadow: "0 0 60px rgba(255, 43, 79, 0.1), inset 0 0 60px rgba(255, 43, 79, 0.02)",
          }}
        >
          {/* Animated corner decorations */}
          <motion.div
            className="absolute top-0 left-0 w-4 h-4"
            style={{ borderTop: "2px solid var(--accent)", borderLeft: "2px solid var(--accent)" }}
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
          <motion.div
            className="absolute top-0 right-0 w-4 h-4"
            style={{ borderTop: "2px solid var(--accent)", borderRight: "2px solid var(--accent)" }}
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
          />
          <motion.div
            className="absolute bottom-0 left-0 w-4 h-4"
            style={{ borderBottom: "2px solid var(--accent)", borderLeft: "2px solid var(--accent)" }}
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity, delay: 1 }}
          />
          <motion.div
            className="absolute bottom-0 right-0 w-4 h-4"
            style={{ borderBottom: "2px solid var(--accent)", borderRight: "2px solid var(--accent)" }}
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 2, repeat: Infinity, delay: 1.5 }}
          />

          <h2
            className="mono mb-4"
            style={{
              fontSize: "clamp(24px, 4vw, 36px)",
              fontWeight: 700,
              letterSpacing: "0.04em",
            }}
          >
            <GlitchText>Ready to stop chasing payments?</GlitchText>
          </h2>

          <motion.div
            className="mono text-sm mb-6 p-3 inline-block"
            style={{
              background: "rgba(255, 43, 79, 0.1)",
              border: "1px solid rgba(255, 43, 79, 0.2)",
              color: "var(--accent-text)",
              letterSpacing: "0.08em",
            }}
            animate={{ 
              boxShadow: [
                "0 0 0 rgba(255, 43, 79, 0)",
                "0 0 20px rgba(255, 43, 79, 0.3)",
                "0 0 0 rgba(255, 43, 79, 0)",
              ]
            }}
            transition={{ duration: 3, repeat: Infinity }}
          >
            Get your demon in under 5 minutes
          </motion.div>

          <p className="mono mb-8" style={{ color: "var(--muted)", maxWidth: "400px", margin: "0 auto 32px", fontSize: "14px" }}>
            Join the businesses that automated their invoicing and got their time back.
          </p>

          <MotionLink
            to="/onboard/intro"
            className="btn-lg btn-primary mono inline-flex"
            onPointerEnter={startLoop}
            onPointerLeave={stopLoop}
            whileHover={{ scale: 1.04, boxShadow: "0 0 40px rgba(255, 43, 79, 0.5)" }}
            whileTap={{ scale: 0.96 }}
            style={{
              padding: "16px 32px",
              fontSize: "14px",
              boxShadow: "0 0 30px rgba(255, 43, 79, 0.3)",
            }}
          >
            <span className="glitch-typewriter">
              <GlyphDisplay characters={characters} display={display} prefix="cta" />
            </span>
          </MotionLink>

          <p className="mono text-xs mt-6" style={{ color: "var(--muted)", letterSpacing: "0.1em" }}>
            NO CREDIT CARD REQUIRED
          </p>
        </motion.div>
      </div>
    </section>
  )
}
